<template>
    <b-button class="w-100 mb-1"
              @click="resetCheckTime" variant="outline-secondary">
        <i class="fa-solid fa-arrows-rotate"></i>
        {{ $t('action-items.reset-check-time') }}
    </b-button>
</template>

<script>
import {useToast} from "vue-toastification";

export default {
    name: "ResetCheckTime",
    props: [
        'uuids'
    ],
    methods: {
        resetCheckTime(){
            let externalCommands = [];
            if(this.uuids.length > 0){
                for(var i = 0; i < this.uuids.length; i++){
                    externalCommands.push({
                        serviceUuid: this.uuids[i].serviceUuid,
                        hostUuid: this.uuids[i].hostUuid,
                        satelliteId: this.uuids[i].satelliteId,
                        command: 'rescheduleService'
                       // command: 'SCHEDULE_FORCED_SVC_CHECK',
                    });
                }
                this.$emit('masscommand', externalCommands);
            }else{
                useToast().error('no services selected', {
                    timeout: 2000
                });
            }
        },
    }
}
</script>

<style scoped>

</style>
